export * from "./products.module";
export * from "./shared";
export * from "./product-filter-bar/product-filter-bar.component";
export * from "./product-photo-for-list-form/product-photo-for-list-form.component";
export * from "./product-header-form/product-header-form.component";
export * from "./product-where-to-buy-form/product-where-to-buy-form.component";



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/index.ts